export default defineNuxtRouteMiddleware(async (to, from) => {


  // if(to.path === '/') {
  //   return navigateTo('/our-service')
  // }

  if(to.path === '/solutions/hazardous-waste-solutions') {
    return navigateTo('/')
  }


  // Products
  if (to.path === '/products/bulk-natural-denatured-ethanol-96-3') {
    return navigateTo('/product/natural-denatured-ethanol-96')
  }

  if (to.path === '/products/bulk-synthetic-denatured-ethanol-70') {
    return navigateTo('/product/synthetic-denatured-ethanol-70')
  }

  if (to.path === '/products/bulk-natural-denatured-ethanol-96') {
    return navigateTo('/product/natural-denatured-ethanol-96')
  }

  if (to.path === '/products/bulk-natural-denatured-ethanol-93-2') {
    return navigateTo('/product/natural-denatured-ethanol-93')
  }

  if (to.path === '/products/bulk-synthetic-denatured-ethanol-99-9') {
    return navigateTo('/product/synthetic-denatured-ethanol-99')
  }

  if (to.path === '/products/bulk-natural-unenatured-ethanol-96-3') {
    return navigateTo('/product/natural-undenatured-ethanol-96')
  }

  if (to.path === '/products/bulk-isopropyl-alcohol-ipa-85') {
    return navigateTo('/product/isopropyl-alcohol-ipa-85')
  }

  if (to.path === '/products/bulk-isopropyl-alcohol-ipa-99-8') {
    return navigateTo('/product/isopropyl-alcohol-ipa-99')
  }

  if (to.path === '/products/bulk-xylene-100') {
    return navigateTo('/product/xylene-100')
  }

  if (to.path === '/products/bulk-methanol-100') {
    return navigateTo('/product/methanol-100')
  }

  if (to.path === '/products/bulk-acetone-100') {
    return navigateTo('/product/acetone-100')
  }

  // Collections sitemap
  if (to.path === '/collections/ethanol-and-ethanol-blends') {
    return navigateTo('/solutions/ethanol-blending')
  }

  if (to.path === '/collections/essential-chemicals') {
    return navigateTo('/solutions/essential-chemicals')
  }

  if (to.path === '/collections/manufactured-products') {
    return navigateTo('/solutions/manufactured-products')
  }

  if (to.path === '/collections/manufacturing-as-a-service') {
    return navigateTo('/')
  }

  if (to.path === '/collections/waste-management') {
    return navigateTo('/')
  }

  if (to.path === '/collections/all-products') {
    return navigateTo('/products')
  }


  // Old pages

  if (to.path === '/blogs/news') {
    return navigateTo('/')
  }

  if (to.path === '/blogs/articles') {
    return navigateTo('/')
  }

  if (to.path === '/blogs/ethanol-articles') {
    return navigateTo('/')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-and-its-production') {
    return navigateTo('/blog/ethanol-and-its-production')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-safety-and-applications') {
    return navigateTo('/blog/safe-handling-ethanol-applications')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-a-key-resource-for-healthier-living-in-sub-saharan-africa') {
    return navigateTo('/blog/ethanol-key-resource-sub-saharan-africa')
  }

  if (to.path === '/blogs/ethanol-articles/pharmaceuticals-find-more-than-one-solution-in-ethanol') {
    return navigateTo('/blog/pharmaceuticals-ethanol-solutions')
  }

  if (to.path === '/blogs/ethanol-articles/xylene-at-a-glance') {
    return navigateTo('/blog/xylene-at-a-glance')
  }

  if (to.path === '/blogs/ethanol-articles/cosmetic-advancement-at-the-make-up-of-ethanol') {
    return navigateTo('/blog/cosmetic-advancement-makeup-ethanol')
  }

  if (to.path === '/blogs/ethanol-articles/a-taste-of-ethanol') {
    return navigateTo('/blog/a-taste-of-ethanol')
  }

  if (to.path === '/blogs/ethanol-articles/isolvents-insights-quarterly-updates-and-news-from-isolvents-may-2023-vol-1') {
    return navigateTo('/')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-a-key-resource-for-healthier-living-in-sub-saharan-africa') {
    return navigateTo('/blog/ethanol-key-resource-sub-saharan-africa')
  }

  if (to.path === '/blogs/ethanol-articles/pharmaceuticals-find-more-than-one-solution-in-ethanol') {
    return navigateTo('/blog/pharmaceuticals-ethanol-solutions')
  }

  if (to.path === '/blogs/ethanol-articles/heavy-fuel-oil-a-sustainable-solution-in-south-africa-s-energy-transition') {
    return navigateTo('/blog/heavy-fuel-oil-south-africa-energy-transition')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-blending-to-innovation-and-beyond') {
    return navigateTo('/blog/ethanol-blending-innovation-beyond')
  }

  if (to.path === '/blogs/ethanol-articles/cosmetic-advancement-at-the-make-up-of-ethanol') {
    return navigateTo('/blog/cosmetic-advancement-makeup-ethanol')
  }

  if (to.path === '/blogs/ethanol-articles/heavy-fuel-oil-a-sustainable-solution-in-south-africa-s-energy-transition') {
    return navigateTo('/blog/heavy-fuel-oil-south-africa-energy-transition')
  }

  if (to.path === '/blogs/ethanol-articles/ethanol-blending-to-innovation-and-beyond') {
    return navigateTo('/blog/ethanol-blending-innovation-beyond')
  }



  // Pages
  if (to.path === '/pages/contact') {
    return navigateTo('/contact-us')
  }

  if (to.path === '/pages/our-story') {
    return navigateTo('/about-us')
  }

  if (to.path === '/pages/our-story') {
    return navigateTo('/about-us')
  }

  if (to.path === '/pages/why-you-can-trust-us') {
    return navigateTo('/about-us')
  }

  if (to.path === '/pages/get-in-touch') {
    return navigateTo('/contact-us')
  }

  if (to.path === '/pages/products') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/ethanol-and-ethanol-blends') {
    return navigateTo('/solutions/ethanol-blending')
  }

  if (to.path === '/pages/essential-chemicals') {
    return navigateTo('/solutions/essential-chemicals')
  }

  if (to.path === '/products/perfume-bases') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/sanitizers') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/manufactured-products') {
    return navigateTo('/solutions/manufactured-products')
  }
  if (to.path === '/pages/hazardous-waste-solutions') {
    return navigateTo('/')
  }

  if (to.path === '/pages/acetone-100') {
    return navigateTo('/product/acetone-100')
  }

  if (to.path === '/pages/turpentine-100') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/methanol-100') {
    return navigateTo('/product/methanol-100')
  }

  if (to.path === '/pages/xylene-100') {
    return navigateTo('/product/xylene-100')
  }

  if (to.path === '/pages/isopropyl-alcohol-ipa-99-8') {
    return navigateTo('/product/isopropyl-alcohol-99.8')
  }

  if (to.path === '/pages/isopropyl-alcohol-ipa-85') {
    return navigateTo('/product/isopropyl-alcohol-85')
  }

  if (to.path === '/pages/isopropyl-alcohol-ipa-70') {
    return navigateTo('/product/isopropyl-alcohol-70-h20')
  }

  if (to.path === '/pages/synthetic-undenatured-ethanol-90') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/synthetic-undenatured-ethanol-99-9') {
    return navigateTo('/product/synthetic-undenatured-ethanol-99.9')
  }

  if (to.path === '/pages/synthetic-denatured-ethanol-99-9') {
    return navigateTo('/product/synthetic-denatured-ethanol-99.9')
  }

  if (to.path === '/pages/synthetic-denatured-ethanol-99-8') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/synthetic-denatured-ethanol-96-9') {
    return navigateTo('/product/synthetic-denatured-ethanol-96.9')
  }

  if (to.path === '/pages/synthetic-denatured-ethanol-95') {
    return navigateTo('/product/synthetic-denatured-ethanol-95')
  }

  if (to.path === '/pages/synthetic-denatured-ethanol-70') {
    return navigateTo('/product/synthetic-denatured-ethanol-70')
  }

  if (to.path === '/pages/031sd-synthetic-denatured-ethanol-70') {
    return navigateTo('/product/synthetic-denatured-ethanol-70')
  }

  if (to.path === '/pages/natural-unenatured-ethanol-96-2') {
    return navigateTo('/product/natural-undenatured-ethanol-96.2')
  }

  if (to.path === '/pages/natural-undenatured-ethanol-99-9') {
    return navigateTo('/product/natural-undenatured-ethanol-99.9')
  }

  if (to.path === '/pages/natural-denatured-ethanol-99-9') {
    return navigateTo('/product/natural-denatured-ethanol-99.9')
  }

  if (to.path === '/pages/natural-denatured-ethanol-99-8') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/natural-denatured-ethanol-96-9') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/natural-denatured-ethanol-96-2bp') {
    return navigateTo('/product/natural-denatured-ethanol-96.2')
  }

  if (to.path === '/pages/natural-denatured-ethanol-96-2') {
    return navigateTo('/product/natural-denatured-ethanol-96.2')
  }

  if (to.path === '/pages/natural-denatured-ethanol-96') {
    return navigateTo('/product/natural-denatured-ethanol-96')
  }

  if (to.path === '/pages/natural-denatured-ethanol-93-2') {
    return navigateTo('/product/natural-denatured-ethanol-93.2')
  }

  if (to.path === '/pages/021nd-natural-denatured-ethanol-93-2') {
    return navigateTo('/product/natural-denatured-ethanol-93.2')
  }

  if (to.path === '/pages/natural-denatured-ethanol-70') {
    return navigateTo('/product/natural-denatured-ethanol-70')
  }

  if (to.path === '/pages/natural-denatured-ethanol-66-7') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/shop') {
    return navigateTo('/products')
  }

  if (to.path === '/pages/current-promotions') {
    return navigateTo('/products')
  }


})